import {AppMainStates, Locales} from "../Constants";
import {URLHelper} from "../../helper/URLHelper";
import {AppConfig, DefaultAppConfig} from "../AppConfig";

export interface AppState {
    readonly itemsToBeLoadedTotal: number;
    readonly itemsToBeLoadedRemaining: number;

    appConfig: AppConfig;

    readonly mainState: string;
    readonly lastMainState: string;

    readonly content: any;
    readonly locale: string;
    readonly locales: string[];
}


export interface IImage {
    readonly $: {
        src: string,
    }
}

// ++++++++++++++++++++++++++++
// Debug console
// ++++++++++++++++++++++++++++

export interface DebugConsoleState {
    readonly debugConsoleOpen: boolean;
}

// ++++++++++++++++++++++++++++
// Overview
// ++++++++++++++++++++++++++++

export interface OverviewState {
    readonly xmlObject: {
        features: {
            feature: any[]
        }[]
    },
    readonly currentSelectedLink: string;
}

// ++++++++++++++++++++++++++++
// Features
// ++++++++++++++++++++++++++++
export interface IFeaturesState {
    readonly currentURL: string;
    readonly lastURL: string;

    readonly data: {
        $: { id: string },
        feature: IFeature[],
    };
    readonly currentFeature: IFeature;
    readonly currentDataType: IFeaturesStateDataType;
}

export interface IFeature {
    readonly $: { url: string },
    type: IFeaturesStateDataType[],
}

export interface IFeaturesStateDataType {
    readonly $: { url: string },
    readonly img: IImage[],
    readonly title: string,
    readonly page: IFeaturesStateDataPage[],
    readonly viewer360: {
        img: IImage[]
    }[];
}

export interface IFeaturesStateDataPage {
    readonly $: { url: string },
    readonly icon: IImage[];
    readonly label: string[];
    readonly tab: IFeaturesStateDataTab[];
}

export interface IFeaturesStateDataTab {
    readonly $: { url: string, type: string }
    readonly label: string[];
    readonly img?: IImage[];
    readonly backgroundImg?: IImage[];
    readonly content?: any[];
    readonly tab: IFeaturesStateDataTab[];
}


// ++++++++++++++++++++++++++++
// All stores
// ++++++++++++++++++++++++++++

export interface StoreState {
    readonly appState: AppState;
    readonly debugConsole: DebugConsoleState;

    readonly overview: OverviewState;
    readonly features: IFeaturesState;
}


const defaultAppState: AppState = {
    appConfig: DefaultAppConfig,
    mainState: AppMainStates.LOADING,
    lastMainState: null,
    content: {},
    itemsToBeLoadedTotal: 0,
    itemsToBeLoadedRemaining: 0,
    locale: (URLHelper.isLocalDev) ? URLHelper.dev_lastSavedLocale() : Locales.DE,
    locales: [Locales.DE, Locales.EN],
};

const defaultOverviewState: OverviewState = {
    xmlObject: {
        features: [
            {
                feature: []
            }
        ]
    },
    currentSelectedLink: '/',
};

const defaultFeatureState: IFeaturesState = {
    currentURL: '',
    lastURL: '',
    data: {
        $: {id: ''},
        feature: [],
    },
    currentFeature: null,
    currentDataType: null,
};

const defaultDebugConsoleState: DebugConsoleState = {
    debugConsoleOpen: false
};


export const defaultRootState: StoreState = {
    appState: defaultAppState,
    overview: defaultOverviewState,
    features: defaultFeatureState,
    debugConsole: defaultDebugConsoleState,
};